// MUI
import { Stack } from "@mui/material";

// Components
import Title from "@Settings/components/SystemSettings/common/Title";
import InfoSubTitle from "@Settings/components/SystemSettings/common/InfoSubTitle";
import SmartSelector from "@Layouts/components/InputComponents/SmartSelector";
import SimpleTextField from "@Layouts/components/InputComponents/SimpleTextField";

// Types
import { TSelectValue } from "@Layouts/components/InputComponents/SmartSelector/interfaces";
import { IAllowableDistance } from "@Settings/types/administrationTools/model";

type AllowableDistanceProps = Readonly<{
	isLoading: boolean;
	allowableDistance: IAllowableDistance | undefined;
	providerDBProperty: string;
	// Callbacks
	onActionUpdate: (value: string | TSelectValue, prop: "distance" | "unit", providerDBProperty: string) => void;
}>;

const unitOptions = [
	{ value: "meter", label: "m" },
	{ value: "feet", label: "ft" },
];
export default function AllowableDistance(props: AllowableDistanceProps) {
	const { allowableDistance } = props;
	const { distance, unit } = allowableDistance ?? {};

	return (
		<Stack spacing={2}>
			<Title title={"Allowable Distance"} />
			<Stack direction={"row"} spacing={4}>
				<Stack>
					<InfoSubTitle title={"Distance"} className={"!mb-[12px]"} />
					<SimpleTextField
						placeholder="Distance"
						onlyNumbers
						text={distance}
						sx={{ width: "175px" }}
						editable
						outlined
						disabled={props.isLoading}
						// Callbacks
						onActionUpdate={(value) => props.onActionUpdate(value, "distance", props.providerDBProperty)}
					/>
				</Stack>
				<Stack>
					<InfoSubTitle title={"Unit"} className={"!mb-[12px]"} />
					<SmartSelector
						selected={unit}
						showBy={"label"}
						selectBy={"value"}
						options={unitOptions}
						disabled={props.isLoading || !distance}
						loading={props.isLoading}
						inputProps={{ placeholder: "Unit", classes: "!w-[80px]" }}
						// Callbacks
						onChangeAction={(value) => props.onActionUpdate(value, "unit", props.providerDBProperty)}
					/>
				</Stack>
			</Stack>
		</Stack>
	);
}
